<span class="status-pill status-{{ status() }}">
    <span class="status-dot" aria-hidden="true"></span>
    <!-- FR-026: the text label is the point. Status is never conveyed by color alone. -->
    <span class="status-label">
        @switch (status()) {
            @case ('critical') {
                Critical
            }
            @case ('warning') {
                Warning
            }
            @case ('ok') {
                OK
            }
            @case ('info') {
                Info
            }
        }
    </span>
</span>
